<script lang="ts">

    import {
        SEARCH__searchExamplesAndIndirectTranslations
    } from "@app/services/i18n.messages";

    import { getMessage } from "@app/services/i18n.service";

    import { generatePhraseUrlForCurrentDictionary } from "@app/services/url-builder.service";
    import { fade } from "svelte/transition";
    import Keyboard from "./Keyboard.svelte";
    import {
        deactivateSearchWidget,
        keyboardActive,
        searchPhrase,
        searchWithWordlistWidgetActive,
        setSimilarPhrasesDummyElementsCount,
        similarPhrases,
    } from "./Search.store";
    import SimilarPhrasesList from "./SimilarPhrasesList.svelte";

    setSimilarPhrasesDummyElementsCount(1);
    let isActive = false;

    let input = document.querySelector<HTMLInputElement>(
        "#search-container input"
    );

    let containerElement: HTMLElement | undefined;
    let searchContainer: HTMLElement | undefined =
        document.getElementById("search-container");

    let isVisible = false;
    function calculateIsVisible() {
        if (!isActive) {
            isVisible = false;
            return false;
        }
        let hasNonEmptyPhrase =
            $searchPhrase && $searchPhrase.trim().length > 0;

        isVisible = $keyboardActive || hasNonEmptyPhrase;
    }

    $: {
        calculateIsVisible();
    }

    searchWithWordlistWidgetActive.subscribe((widgetActive) => {
        isActive = widgetActive;
        calculateIsVisible();
    });
    keyboardActive.subscribe(() => {
        calculateIsVisible();
    });
    searchPhrase.subscribe(() => {
        calculateIsVisible();
    });

    function closeOnClickOutside(event: Event) {
        const target = event.target as HTMLElement;
        if (isVisible) {
            let deactivate = false;
            if (containerElement && !containerElement.contains(target)) {
                deactivate = true;
            }
            if (
                deactivate &&
                searchContainer &&
                searchContainer.contains(target)
            ) {
                deactivate = false;
            }
            if (deactivate) {
                deactivateSearchWidget();
            }
        }
    }
    let hasTouchMove = false;
    window.document.addEventListener(
        "touchend",
        function (touchEvent: TouchEvent) {
            if (!hasTouchMove) {
                closeOnClickOutside(touchEvent);
            }
        }
    );
    window.document.addEventListener("touchstart", function () {
        hasTouchMove = false;
    });
    window.document.addEventListener("touchmove", function () {
        hasTouchMove = true;
    });
</script>

<svelte:window on:click={closeOnClickOutside} />
{#if isVisible}
    <div class="relative w-full" bind:this={containerElement}>
        <div
            class="bg-white mainWordlistContainer shadow lg border-b border-gray-100"
            class:mainWordlistContainer__active={$searchWithWordlistWidgetActive}
            transition:fade={{ duration: 150 }}
        >
            <Keyboard {input} inline={true} />

            {#if $searchPhrase && $searchPhrase.trim().length > 0}
                <div class="pt-2">
                    <a
                        href={generatePhraseUrlForCurrentDictionary(
                            $searchPhrase
                        )}
                        class="block p-2 flex items-center bg-white transition-all duration-300"
                        class:border-tertiary-600={$similarPhrases.straight.currentPosition === 0}
                        class:border-transparent={$similarPhrases.straight.currentPosition !== 0}
                    >
                        <div class="flex-1 truncate">
                            <strong class="text-primary-800 block text-lg"
                                >{$searchPhrase}
                            </strong>
                            <span class="text-xs text-gray-700 ">
                                {getMessage(
                                    SEARCH__searchExamplesAndIndirectTranslations
                                )}
                            </span>
                        </div>
                        <div class="text-xs">
                            <span class="icon-chevron-right" />
                        </div>
                    </a>
                </div>

                <div class="py-1 mt-2">
                    <SimilarPhrasesList activeItem={$similarPhrases.straight.currentPosition - 1} reverse="{false}"/>
                    <SimilarPhrasesList activeItem={$similarPhrases.reverse.currentPosition - 1} reverse="{true}"/>
                </div>
            {/if}
        </div>
    </div>
{/if}

<style>
    .mainWordlistContainer {
        z-index: 50;
        position: absolute;
        left: 0;
        right: 0;
    }
    .mainWordlistContainer__active {
        height: auto;
    }
</style>
